/* global Blockly */
import React from 'react';
import { _defineHelpUrlandToolTip } from '../../helpers/index.js'

function defineBlock() {
    return {
        init: function () {
            this.appendValueInput("OBJ")
                .appendField("convert JSON object")
                .setCheck(["Object", "Array"]);
            this.appendDummyInput("desc")
                .appendField("to text");
            this.setColour(Blockly.Msg.LISTS_HUE);
            this.setOutput(true, "String");
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setTooltip("Convert a JSON object into its text form.");
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#lists");
        }
    };
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let obj = Blockly.JavaScript.valueToCode(block, "OBJ", Blockly.JavaScript.ORDER_NONE);
            let code = `(function() {
                try {
                    return JSON.stringify(${obj});
                } catch (e) {
                    console.error("Error stringifying JSON object:", e.message);
                    return "";
                }
            })()`;
            return [code, Blockly.JavaScript.ORDER_FUNCTION_CALL];
        }
    };
}

const StringifyJSON = function () {
    let name = "stringify_json";
    StringifyJSON.blockName = name;

    Blockly.Blocks[name] = defineBlock();
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }
    
    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#lists");

    return (
        <block type={name}></block>
    );
};

export default StringifyJSON;
